import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, useLocation, useHistory } from 'react-router-dom';

import { checkUserActivity } from '../modules/App/CheckUserActivity';
import { checkLastRouteRequest } from '../modules/App/redux/actions/check_last_route.actions';

// APP
import TopBar from '../modules/App/components/topbar/Topbar';
import Sidebar from '../modules/App/components/sidebar/Sidebar';
import MainWrapper from '../modules/App/MainWrapper';
import CheckUserActivityModal from '../modules/App/CheckUserActivityModal';
import ModalWindow from '../common/components/modalWindow';

const mapStateToProps = (state) => ({ visible: state.App.Login_form.visible });

class Router extends Component {
    componentDidMount() {
        checkUserActivity(this.props);
    }

    render() {
        const { routes, visible } = this.props;

        return (
            <MainWrapper>
                <TopBar />
                <Sidebar />
                <ModalWindow />
                <div className="container__wrap">
                    <Switch>
                        {
                            routes.map((route) => <Route key={route.path} path={route.path} component={route.component} />)
                        }
                    </Switch>
                </div>
                { visible && <CheckUserActivityModal /> }
            </MainWrapper>
        );
    }
}

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./src/router/Router.js